module.exports = __webpack_public_path__ + "img/style2_platform_logo_589af4fb6.png";